/* eslint-disable array-callback-return */
import React from "react";
import {
  Box,
  List,
  ListItemText,
  ListItemAvatar,
  Typography,
  ListItemButton,
} from "@common-ui/ui";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
// import { useHistory } from "react-router-dom";
import { AssetImage } from "./AseetImage";

export const AssetListView = (props) => {
  let { handleModal } = React.useContext(ModalContext);
  let data = props.rows;
  // let router = useHistory();
  const listItem = (item, divider = false) => (
    <ListItemButton
      divider={divider}
      alignItems="flex-start"
      sx={{ width: "100%", maxWidth: "100%", pl: 0, pr: 0 }}
      style={{ cursor: "pointer" }}
      onClick={() =>
        // router.push({
        //   pathname: `/customers/${item.system_id}/${item.orgId}`,
        // })
        handleModal("Coming Soon!", "Alert")
      }
    >
      <ListItemAvatar>
        <AssetImage asset={item} />
      </ListItemAvatar>
      <ListItemText
        primary={item.make}
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.secondary"
            >
              Make: {item.make || "None"} | Model: {item.model || "None"}
            </Typography>{" "}
            - Serial Number: {item.serial_number || "None"}
          </React.Fragment>
        }
      />
    </ListItemButton>
  );
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
        }}
      >
        <List
          sx={{ width: "100%", maxWidth: "100%", bgcolor: "background.paper" }}
        >
          {Array.from(data).map((dataItem, i) => {
            try {
              if (i === data.length - 1) {
                return listItem(dataItem);
              }
              return listItem(dataItem, true);
            } catch (error) {
              console.log(error);
            }
          })}
        </List>
      </Box>
    </>
  );
};
